// Feature switches of the room occupancy overlay.
//
// "Planifier ici" (phase 2) is built but not yet validated: it stays available
// on staging and local development only until the open bugs are worked
// through. Production can turn it on later with VITE_FEATURE_PLAN_HERE=true.
export function isPlanHereEnabled(): boolean {
  if (import.meta.env.VITE_FEATURE_PLAN_HERE === 'true') return true;
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host.includes('.staging.');
}
